/** Operator-facing labels — contact/follow-up emphasis; no payment/settlement wording. */

export const COLLECTION_CONTACT_FLOW_OPERATOR_LABELS = {
  actionStart: '채권 연락·팔로업 시작',
  openSuccess: '채권 연락·팔로업을 시작했습니다.',
  openResumed: '진행 중인 채권 연락·팔로업을 엽니다.',
  openFailed: '채권 연락·팔로업을 시작하지 못했습니다.',
  unwiredHandler: '채권 연락·팔로업 실행 경로가 연결되지 않았습니다.',
  missingArEntry:
    '선택한 항목에서 AR ID를 확인할 수 없습니다. 미수금(AR) 목록에서 다시 선택해 주세요.',
} as const;
